export interface SiteFormInitialValues {
  id?: string;
  name: string;
  organization: string;

  // Location
  address: string;
  address_2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  phone_number: string;
  latitude: string;
  longitude: string;
  elevation: string;

  // Licensing
  licensed: boolean;

  // Alerts
  drill_enabled: boolean;
  show_safe_unsafe: boolean;

  // Pre-selected Provider Orgs
  preselected_provider_ids?: string[];
}
export const SiteFormInitialValuesObj: SiteFormInitialValues = {
  id: '',
  name: '',
  organization: '',

  // Location
  address: '',
  address_2: '',
  city: '',
  state: '',
  zip: '',
  country: '',
  phone_number: '',
  latitude: '',
  longitude: '',
  elevation: '',

  // Licensing
  licensed: false,

  // Alerts
  drill_enabled: true,
  show_safe_unsafe: true,

  // Pre-selected Provider Orgs
  preselected_provider_ids: [],
};
